import type { Currency, Minor } from './types'

const SYMBOL: Record<Currency, string> = {
  ZAR: 'R',
  GBP: '£',
  EUR: '€',
  USD: '$',
}

/** South African convention groups thousands with a space rather than a comma. */
const GROUP_SEPARATOR: Record<Currency, string> = {
  ZAR: ' ',
  GBP: ',',
  EUR: ',',
  USD: ',',
}

/** Format integer minor units for display. Never used for arithmetic. */
export function formatMoney(minor: Minor, currency: Currency = 'ZAR'): string {
  const negative = minor < 0
  const abs = Math.abs(minor)
  const major = Math.floor(abs / 100)
  const cents = abs % 100
  const grouped = String(major).replace(/\B(?=(\d{3})+(?!\d))/g, GROUP_SEPARATOR[currency])
  return `${negative ? '-' : ''}${SYMBOL[currency]}${grouped}.${String(cents).padStart(2, '0')}`
}

/** Parse a typed amount such as "248.00" into minor units. Returns null if unusable. */
export function parseMoney(input: string): Minor | null {
  const trimmed = input.trim().replace(/[R£€$,\s ]/g, '')
  if (!/^\d+(\.\d{0,2})?$/.test(trimmed)) return null
  const [whole = '0', frac = ''] = trimmed.split('.')
  return Number(whole) * 100 + Number(frac.padEnd(2, '0'))
}

/** Basis points of an amount, rounded to the nearest cent. */
export function bps(amountMinor: Minor, basisPoints: number): Minor {
  return Math.round((amountMinor * basisPoints) / 10_000)
}
